var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrawing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Drawing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4299",
    "data-name": "Path 4299",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4300",
    "data-name": "Path 4300",
    d: "M7.05,14.121,4.93,16.243l2.828,2.828L19.071,7.757,16.243,4.93,14.12,7.05l1.415,1.414L14.12,9.88,12.706,8.465,11.292,9.88l1.414,1.414-1.414,1.414L9.878,11.294,8.463,12.708l1.415,1.414L8.463,15.537,7.05,14.12Zm9.9-11.313L21.192,7.05a1,1,0,0,1,0,1.414L8.464,21.192a1,1,0,0,1-1.414,0L2.808,16.95a1,1,0,0,1,0-1.414L15.536,2.808A1,1,0,0,1,16.95,2.808ZM14.12,18.363l1.415-1.414,2.242,2.243h1.414V17.778l-2.242-2.243,1.414-1.414L21,16.757V21H16.758l-2.637-2.637ZM5.636,9.878,2.807,7.05a1,1,0,0,1,0-1.415L5.636,2.807a1,1,0,0,1,1.414,0L9.88,5.635,8.464,7.05,6.343,4.928,4.929,6.343,7.05,8.463,5.636,9.878Z",
    fill: "#2b2d42"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawing);
export default __webpack_public_path__ + "static/media/drawing.8b5658f5ab93749f841d1365e8111e33.svg";
export { ForwardRef as ReactComponent };